export var uiArrowUp = [
    'M2.86 8.18L3.02 8.35C3.14 8.47 3.3 8.47 3.42 8.35L7.59 4.18L7.59 12.97C7.59 13.13 7.73 13.25 7.87 13.25L8.11 13.25C8.27 13.25 8.39 13.13 8.39 12.97L8.39 4.18L12.58 8.35C12.7 8.47 12.86 8.47 12.98 8.35L13.14 8.18C13.26 8.07 13.26 7.9 13.14 7.79L8.2 2.84C8.08 2.72 7.92 2.72 7.8 2.84L2.86 7.79C2.74 7.9 2.74 8.07 2.86 8.18Z',
];
